import { Card } from "@components/ui/card";
import { useAppDispatch } from "@store";
import { closeDialog } from "@store/dialogs";
import { useGetFolderByIdQuery } from "@/shared/services";
import type { IStoriesFolder } from "@/shared/types";
import { MoveFolderCtxProvider } from "../ctx";
import { MoveFolderBody } from "./move-folder-dialog-body";
import { MoveFolderFooter } from "./move-folder-dialog-footer";
import { MoveFolderHeader } from "./move-folder-dialog-header";

const DIALOG_ID = "move-folder";

interface IProps {
  folderId: string;
  folderName?: string;
}

export const MoveFolderDialog = ({ folderId, folderName }: IProps) => {
  const dispatch = useAppDispatch();
  const { data: folderData } = useGetFolderByIdQuery(folderId);

  const handleClose = () => {
    dispatch(closeDialog(DIALOG_ID));
  };

  const providerProps = {
    folderId,
    folderData: folderData as IStoriesFolder,
    closeDialog: handleClose,
    ...(folderName !== undefined && { folderName }),
  };

  return (
    <MoveFolderCtxProvider {...providerProps}>
      <Card className="tw-w-[512px]">
        <MoveFolderHeader />
        <MoveFolderBody />
        <MoveFolderFooter />
      </Card>
    </MoveFolderCtxProvider>
  );
};

MoveFolderDialog.id = DIALOG_ID;
